import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FormDropdown as Dropdown } from '@ami/react/core';
import { CreateQuoteStep1 } from '../../quotes/otherQuoteEntities';
import { PriceZoneSummary } from '../../price-zones/priceZone';
import { appConfig } from '@ami/react/core';
import { DealerGroupsAsyncDropdown } from '../../dealer-groups/DealerGroupsAsyncDropdown';
import { DealerBranchesAsyncDropdown } from '../../dealer-branches/DealerBranchesAsyncDropdown';

export default class CreateQuoteStep1Branch extends PureComponent {
  static propTypes = {
    data: PropTypes.instanceOf(CreateQuoteStep1).isRequired,
    onUpdate: PropTypes.func.isRequired,
    priceZones: PropTypes.arrayOf(PropTypes.instanceOf(PriceZoneSummary))
      .isRequired,
  };

  getValidPriceZones = (priceZones, dealerBranchSummary) => {
    if (!dealerBranchSummary) {
      return [];
    }
    return priceZones.filter(
      (x) => x.isoCurrencySymbol === dealerBranchSummary.isoCurrencySymbol
    );
  };

  render() {
    const { data, priceZones, onUpdate } = this.props;

    return (
      <Fragment>
        {appConfig.isManagementApp && (
          <div className="row">
            <div className="col-md-4 form-group">
              <label className="form-label">Dealer Group</label>
              <DealerGroupsAsyncDropdown
                placeholder="Select a dealer group..."
                required
                onChange={(dealerGroup) =>
                  onUpdate({
                    dealerGroupId: dealerGroup ? dealerGroup.id : null,
                    dealerGroupName: dealerGroup ? dealerGroup.label : null,
                    dealerBranchId: null,
                    priceZoneId: null,
                  })
                }
                selected={
                  data.dealerGroupId
                    ? {
                        id: data.dealerGroupId,
                        label: data.dealerGroupName,
                      }
                    : null
                }
                autoFocus={true}
              />
            </div>
            <div className="col-md-4 form-group">
              <label className="form-label">Dealer Branch</label>
              <DealerBranchesAsyncDropdown
                placeholder="Select a dealer branch..."
                noOptions={
                  data.dealerGroupId
                    ? 'Enter a search term...'
                    : 'Please select a dealer group first'
                }
                required
                dealerGroupId={data.dealerGroupId}
                onChange={(dealerBranch) =>
                  onUpdate({
                    dealerBranchId:
                      dealerBranch && dealerBranch !== null
                        ? dealerBranch.id
                        : null,
                    dealerBranchName:
                      dealerBranch && dealerBranch !== null
                        ? dealerBranch.label
                        : null,
                    priceZoneId:
                      dealerBranch && dealerBranch !== null
                        ? dealerBranch.original.priceZoneId
                        : null,
                    dealerBranchSummary:
                      dealerBranch && dealerBranch !== null
                        ? dealerBranch.original
                        : null,
                  })
                }
                selected={
                  data.dealerBranchId
                    ? {
                        id: data.dealerBranchId,
                        label: data.dealerBranchName,
                      }
                    : null
                }
              />
            </div>
            <div className="col-md-4">
              <Dropdown
                label="Price Zone"
                required
                items={this.getValidPriceZones(
                  priceZones,
                  data.dealerBranchSummary
                )}
                placeholder="Select a price zone..."
                selectedId={data.priceZoneId}
                onChange={(priceZoneId) => onUpdate({ priceZoneId })}
              />
            </div>
          </div>
        )}
        {appConfig.isDealerApp && (
          <div className="row">
            <div className="col-md-6 offset-md-3">
              <DealerBranchesAsyncDropdown
                placeholder="Select a dealer branch..."
                noOptions={'Enter a branch name...'}
                required
                dealerGroupId={data.dealerGroupId}
                onChange={(dealerBranch) =>
                  onUpdate({
                    dealerBranchId:
                      dealerBranch && dealerBranch !== null
                        ? dealerBranch.id
                        : null,
                    dealerBranchName:
                      dealerBranch && dealerBranch !== null
                        ? dealerBranch.label
                        : null,
                    priceZoneId:
                      dealerBranch && dealerBranch !== null
                        ? dealerBranch.original.priceZoneId
                        : null,
                    dealerBranchSummary:
                      dealerBranch && dealerBranch !== null
                        ? dealerBranch.original
                        : null,
                  })
                }
                selected={
                  data.dealerBranchId
                    ? {
                        id: data.dealerBranchId,
                        label: data.dealerBranchName,
                      }
                    : null
                }
              />
            </div>
          </div>
        )}
      </Fragment>
    );
  }
}
